import React from 'react';

import appRouterService from '@/services/route/appRouterService';

import DevicesSettingsSectionNew from '../../../DevicesSettingsSection/DevicesSettingsSectionNew';
import {useIlluminationModeContent} from './useIlluminationModeContent';

const IlluminationModeButton = (props) => {
    const content = useIlluminationModeContent();

    if (!content) {
        return null;
    }

    const {title, currentValue} = content;

    return (
        <DevicesSettingsSectionNew.Button
            {...props}
            title={title}
            subTitle={currentValue?.icon?.title}
            icon={currentValue?.icon}
            onClick={() => {
                appRouterService.forwardToIlluminationModePage();
            }}
        />
    );
};

export default IlluminationModeButton;
